import React from "react";

const CORNERS = [
  { key: "top-left", style: "cy:top-4 cy:left-4" },
  { key: "top-right", style: "cy:top-4 cy:right-4" },
  { key: "bottom-left", style: "cy:bottom-4 cy:left-4" },
  { key: "bottom-right", style: "cy:bottom-4 cy:right-4" },
];

type Position = "top-left" | "top-right" | "bottom-left" | "bottom-right";

interface PositionPickerProps {
  value: string;
  onChange: (value: Position) => void;
  device?: "desktop" | "mobile";
}

export const PositionPicker: React.FC<PositionPickerProps> = ({ value, onChange, device = "desktop" }) => {
  const isMobile = device === "mobile";
  
  return (
    <div className={`cy:relative cy:bg-[#f4f8fe] cy:border cy:border-[#bfc7db] cy:rounded-xl ${
      isMobile ? "cy:w-[128px] cy:h-[200px]" : "cy:w-[295px] cy:h-[200px]"
    }`}>
      {CORNERS.map((corner) => (
        <button
          key={corner.key}
          type="button"
          aria-label={corner.key.replace("-", " ")}
          className={`cy:absolute ${corner.style} cy:w-[24px] cy:h-[24px] cy:rounded-full cy:border-3 cy:flex cy:items-center cy:justify-center cy:transition
            ${value === corner.key
              ? "cy:bg-[#1578F7] cy:border-[#1578F7]"
              : "cy:bg-white cy:border-[#bfc7db]"}
          `}
          onClick={() => onChange(corner.key as Position)}
        >
          {value === corner.key && (
            <span className="cy:block cy:w-3 cy:h-3 cy:bg-white cy:rounded-full" />
          )}
        </button>
      ))}
    </div>
  );
};